import React from 'react';
import styles from './label.module.scss';
import clsx from 'clsx';
import AlertIcon from "../../assets/images/alert-red.svg";

interface LabelProps {
  label?: string;
  required?: boolean;
  alert?: boolean;
  className?: string;
  name?: string;
}

const Label: React.FC<LabelProps> = ({
  label,
  required,
  alert,
  className,
  ...props
}) => {
  if (!label) return null;
  return (
    <label {...props} className={clsx(styles.label, className)}>
      {label}
      {required ? <sup className={styles.required}>*</sup> : null}
      {alert ? <img className={styles.alert} src={AlertIcon} /> : null}
    </label>
  );
};

export default Label;
